import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import firebase from '../Firebase';

class Register extends React.Component {
  constructor(props){
    super(props);
    this.props = props;
    this.state = {email: "", password: "", repeat: "", loggedIn: false}
  }

  componentDidMount = () => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({loggedIn: true});
      } else {
        // User is signed out.
      }
    });
  }

  handleRegisterClick = () => {

    if(this.state.email != undefined && this.state.password != undefined){
      var email = this.state.email;
      var password = this.state.password;

      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION).then(() => {
        return firebase.auth().createUserWithEmailAndPassword(email, password);
      }).then((authResult) => {
        this.setState({loggedIn: true});
      }).catch(function(error) {
        var errorCode = error.code;
        var errorMessage = error.message;
        alert("Errors " + errorMessage);
      });
    }else{
      alert("Email and password are required");
    }
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  render() {
    if (this.state.loggedIn === true) {
      return <Redirect to='/videos' />
    }

    return (
      <div>
        <Link to="/">Login</Link>
        <h1>Register</h1>
        <p>
          <input type="text" name="firstName" placeholder="First Name" onChange={this.handleInputChange} />
          <input type="text" name="lastName" placeholder="Last Name" onChange={this.handleInputChange} />
        </p>
        <p>
          <input type="text" name="businessName" placeholder="Business Name" onChange={this.handleInputChange} />
        </p>
        <p>
          <input type="text" name="email" placeholder="Email" onChange={this.handleInputChange} />
        </p>
        <p>
          <input type="password" name="password" placeholder="Create a new password" onChange={this.handleInputChange} />
        </p>
        <p>
          <input type="password" name="repeatPassword" placeholder="Retype password" onChange={this.handleInputChange} />
        </p>
        <a href="#" onClick={this.handleRegisterClick} >Register Button</a>
      </div>
    )
  }
}

export default Register;